import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { getLMSUserPermissionAPI, updateLMSUserPermissionAPI } from "../../../api/LMS/master";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/Component";
import { Tooltip } from "reactstrap";
import useLogout from "../../../hooks/useLogout";

const Permission = () => {
  const [sm, updateSm] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [progress, setProgress] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [roleDropList, setRoleDropList] = useState([]);
  const [selectedRoleOption, setSelectedRoleOption] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [tooltipOpen, setOpen] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);
   const toggle = () => {
    setOpen(!tooltipOpen);
  };
  const navigate = useNavigate()
  const logout = useLogout()
  const location =  useLocation()
  const user = location?.state;
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      permissionList: null,
    },
  });
  useEffect(() => {
    const body = {
      userId: user?.id,
    };
    getUserPermission(body);
  }, [location]);



    // function to change the check property of an item
  const selectorCheckCreate = (e) => {
    let newData;
    newData = data.map((item) => {
      item.isCreate = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
    setUpdatedData([...data])
  };
  // function to change the selected property of an item
  const onSelectChangeCreate = (e, uniqueId) => {
    // let newData = data;
    // let index = newData.findIndex((item) => item.id === id);
    // newData[index].create = e.currentTarget.checked;
    // setData([...newData]);

    let index = data.findIndex((item) => item.uniqueId === uniqueId);
    if (index !== -1) {
      let newData = [...data];
      newData[index].isCreate = e.currentTarget.checked;
      setData(newData);
      // Update the updatedData state
      let updatedItemIndex = updatedData.findIndex((item) => item.uniqueId === uniqueId);
      if (updatedItemIndex !== -1) {
        let updatedDataCopy = [...updatedData];
        updatedDataCopy[updatedItemIndex] = newData[index];
        setUpdatedData(updatedDataCopy);
      } else {
        setUpdatedData([...updatedData, newData[index]]);
      }
    } else {
      console.log("hi! from else block!");
    }
  };
    // function to change the check property of an item
  const selectorCheckView = (e) => {
    let newData;
    newData = data.map((item) => {
      item.isView = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
    setUpdatedData([...data])
  };
  // function to change the selected property of an item
  const onSelectChangeView = (e, uniqueId) => {
    // let newData = data;
    // let index = newData.findIndex((item) => item.id === id);
    // newData[index].view = e.currentTarget.checked;
    // setData([...newData]);
    let index = data.findIndex((item) => item.uniqueId === uniqueId);
    if (index !== -1) {
      let newData = [...data];
      newData[index].isView = e.currentTarget.checked;
      setData(newData);
      // Update the updatedData state
      let updatedItemIndex = updatedData.findIndex((item) => item.uniqueId === uniqueId);
      if (updatedItemIndex !== -1) {
        let updatedDataCopy = [...updatedData];
        updatedDataCopy[updatedItemIndex] = newData[index];
        setUpdatedData(updatedDataCopy);
      } else {
        setUpdatedData([...updatedData, newData[index]]);
      }
    } else {
      console.log("hi! from else block!");
    }
  };
  // function to change the check property of an item
  const selectorCheckUpdate = (e) => {
    let newData;
    newData = data.map((item) => {
      item.isUpdate = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
    setUpdatedData([...data]);
  };

  const onSelectChangeUpdate = (e, uniqueId) => {
    let index = data.findIndex((item) => item.uniqueId === uniqueId);
    if (index !== -1) {
      let newData = [...data];
      newData[index].isUpdate = e.currentTarget.checked;
      setData(newData);
      // Update the updatedData state
      let updatedItemIndex = updatedData.findIndex((item) => item.uniqueId === uniqueId);
      if (updatedItemIndex !== -1) {
        let updatedDataCopy = [...updatedData];
        updatedDataCopy[updatedItemIndex] = newData[index];
        setUpdatedData(updatedDataCopy);
      } else {
        setUpdatedData([...updatedData, newData[index]]);
      }
    } else {
      console.log("hi! from else block!");
    }
  };
  const getUserPermission = (data) => {
    setIsLoading(true);
    getLMSUserPermissionAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setValue("permissionList", res.data.data);
          setData(  res.data.data);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (!status) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("permissionList", []);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const onActionClick = (e) => {
    e.preventDefault();
    const bodyData = {
      userId:location?.state?.id,
      data:data
    } 
   
    setIsLoading(true)
    setProgress(75)
    updateLMSUserPermissionAPI(bodyData).then((res)=>{
      if(res.data.status){
        setIsLoading(false)
        setProgress(95)
        toast.success(res.data.message) 
        navigate(-1)
      }else if(!res.data.status){
        toast.error(res.data.message)
        setIsLoading(false)
        setProgress(0)
      }else if(res.data.status=="expired"){
         toast.error(res.data.message)
        setIsLoading(false)
        setProgress(0);
        logout()
      }
    })  .catch((err) => {
        setIsLoading(false);
      });
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data?.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <>
      <Head title="User Permission | Menu" />
     <Content>
        <BlockHead className={`${isLoading ? "myclass" : ""} `} size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3">User Permission Menu List</BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {currentItems?.length} menu</p>
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <DataTable className="card-streach">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools">
                  <div className="form-inline flex-nowrap gx-3">
                    <span className="h6 text-soft">{location?.state?.label}</span>                  
                    {currentItems?.length ? (
                      <div className="btn-wrap">
                        <span className="d-md-block d-none">
                          <Button color="primary" id="id" onClick={(e) => onActionClick(e)}>
                            Save
                          </Button>
                          <Tooltip placement="right" isOpen={tooltipOpen} target="id" toggle={toggle}>
                            save new changes
                          </Tooltip>
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody>
              <DataTableHead>
                <DataTableRow className="nk-tb-col-check">
                  <span className="sub-text">Menu</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-check">
                  <span className="sub-text">Sub-Menu</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-check">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={(e) => selectorCheckCreate(e)}
                      id="uid-1"
                    />
                    <label className="custom-control-label" htmlFor="uid-1">
                      Create
                    </label>
                  </div>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-check">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={(e) => selectorCheckView(e)}
                      id="uid-2"
                    />
                    <label className="custom-control-label" htmlFor="uid-2">
                      View
                    </label>
                  </div>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-check">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={(e) => selectorCheckUpdate(e)}
                      id="uid-3"
                    />
                    <label className="custom-control-label" htmlFor="uid-3">
                      Update
                    </label>
                  </div>
                </DataTableRow>
              </DataTableHead>
              {currentItems?.length > 0
                ? data?.map((item, index) => {
                    return (
                      <DataTableItem key={index}>
                        <DataTableRow>
                          <span>{item.menu_name}</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span>{item.sub_menu}</span>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-check">
                          <div className="custom-control custom-control-sm custom-checkbox notext">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              defaultChecked={item.isCreate}
                              id={item.uniqueId}
                              key={Math.random()}
                              onChange={(e) => onSelectChangeCreate(e, item.uniqueId)}
                            />
                            <label className="custom-control-label" htmlFor={item.uniqueId}></label>
                          </div>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-check">
                          <div className="custom-control custom-control-sm custom-checkbox notext">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              defaultChecked={item.isView}
                              id={item.uniqueId+"ui3"}
                              key={Math.random()}
                              onChange={(e) => onSelectChangeView(e, item.uniqueId)}
                            />
                            <label className="custom-control-label" htmlFor={item.uniqueId +"ui3"}></label>
                          </div>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-check">
                          <div className="custom-control custom-control-sm custom-checkbox notext">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              defaultChecked={item.isUpdate}
                              id={item.uniqueId+"ui1"}
                              key={Math.random()}
                              onChange={(e) => onSelectChangeUpdate(e, item.uniqueId)}
                            />
                            <label className="custom-control-label" htmlFor={item.uniqueId+"ui1"}></label>
                          </div>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            {/* <div className="card-inner">
              {currentItems?.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={data?.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div> */}
          </DataTable>
        </Block>
      </Content>
    </>
  );
};

export default Permission;
